import React from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import InterviewQuestionGuide from './interviewQuestionGuides';
import CompetencyInnerCard from '../common/competencyInnerCard';
import CompetencyCard from '../common/competencyCard';
import classNames from 'classnames/bind';
import styles from './interviewGuide.module.scss';

const cx = classNames.bind(styles);

const strengthQuestionGuidesTooltipContent = (
  <>
    <p>응시자님의 역량 강점과 관련된 대표적인 예상 면접 질문과 가이드를 제공합니다.</p>
    <p>응시자님이 가진 강점을 어떻게 더 잘 강조하여 어필할 수 있을지 면접 가이드를 활용하여 준비해보세요.</p>
  </>
);

const weaknessQuestionGuidesTooltipContent = (
  <>
    <p>응시자님의 역량 약점과 관련된 대표적인 예상 면접 질문과 가이드를 제공합니다.</p>
    <p>응시자님이 가진 약점을 어떻게 주의하여 잘 전달할 수 있을지 면접 가이드를 활용하여 준비해보세요.</p>
  </>
);

const InterviewGuide = () => {
  const { accaResultStore } = useResultStore();
  const { accProfileResult } = accaResultStore;

  if (!accProfileResult) return null;

  const { strengths, weaknesses } = accProfileResult;

  return (
    <CompetencyCard title={`면접 예상 질문 및 가이드`} cardType={'gray'} iconType={'guide'}>
      <div className={cx('wrapper')}>
        <CompetencyInnerCard
          title={'강점을 돋보여줄 역량 면접 가이드'}
          subTitle={'강점 역량과 관련된 대표적인 면접 질문입니다. 미리 준비해보세요.'}
          tooltipContent={strengthQuestionGuidesTooltipContent}
        >
          <InterviewQuestionGuide subFactors={strengths} />
        </CompetencyInnerCard>
        <CompetencyInnerCard
          title={'주의해야 할 약점 역량 면접 가이드'}
          subTitle={'주의해야 할 역량과 관련된 대표적인 면접 질문입니다. 미리 준비해보세요.'}
          tooltipContent={weaknessQuestionGuidesTooltipContent}
        >
          <InterviewQuestionGuide subFactors={weaknesses} />
        </CompetencyInnerCard>
        <p className={cx('noticeText')}>
          면접 예상 질문 및 가이드에서 제공되는 면접 질문과 가이드는 실제 기업 채용에서 제시되는 내용과 구성이 다를 수
          있습니다.
        </p>
      </div>
    </CompetencyCard>
  );
};

export default InterviewGuide;
